// integration with @sentry/react

import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';
// biome-ignore lint/style/noRestrictedImports: legacy import pattern
import { Route as RouteOriginal } from 'react-router-dom';

export {
  Link,
  Route as RouteOriginal,
  Router,
  Switch,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
  // biome-ignore lint/style/noRestrictedImports: legacy import pattern
} from 'react-router-dom';

// Create Custom Sentry Route component
export const Route = Sentry.withSentryRouting(RouteOriginal);

export const history = createBrowserHistory();
